// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__l2WJ5","noHoverBg":"CellularCapability_noHoverBg__-ZqZL"};